
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import Pop from "../components/blue-pop.vue";
import {
  QuestionV2Object,
  QuestionV2,
  EnumQuestionType
} from "@/lib/model/exambuilder/question-v2";
import {
  DimensionObject,
  QuestionDimension
} from "@/lib/model/exambuilder/dimension-v2";
import {
  ExamV2Custom,
  StructExamScoreConfig,
  StructExamQuestionConfig,
  StructExamRandomConfig,
  ChoiceQuestionScore,
  StructRandomQuestionScoreConfig
} from "@/lib/model/exambuilder/exam-v2";
import questionGroupEdit from "../components/question-group-edit.vue";

@Component({
  components: { questionGroupEdit, Pop }
})
export default class QuestionGroupCard extends Vue {
  @Prop({ type: ExamV2Custom, default: new ExamV2Custom() })
  exam!: ExamV2Custom; //考试Model
  @Prop({ type: Array, default: [new QuestionV2()] })
  questionList!: QuestionV2[];
  //@Prop({ type: QuestionV2, default: new QuestionV2() }) question!: QuestionV2; //题目model
  @Prop({ type: StructExamRandomConfig, default: new QuestionV2() })
  questionGroup!: StructExamRandomConfig; //题目model

  @Prop({ type: String, default: "" }) mode!: string; // 提卡模式 select = 选择模式; selected = 已经选择模式;score = 分数设置模式
  @Prop({ type: Array, default: null }) actions!: Array<any> | null;
  // 题目序号
  @Prop({ type: Number, default: 0 }) totalCount!: number;
  @Prop({ type: Number, default: 0 }) examDrawQuestionsCount!: number; //面试抽题总数量
  @Prop({ type: Number, default: 0 }) index!: number;
  @Prop({ type: Map, default: null }) dimensionMap!: Map<
    string,
    QuestionDimension
  >; // 维度map，需要使用维度数据时从map里取
  @Prop({ type: QuestionDimension, default: null })
  currentDimension!: QuestionDimension | null;
  @Prop({ type: Boolean, default: false }) showAllDimension!: boolean;
  @Prop({ type: Boolean, default: true }) canEditScore!: boolean;
  @Prop({ type: Object, default: () => ({}) }) questionIdMap!: any;
  @Prop({ type: Array, default: null }) scoreConfigList!: Array<any> | null;
  @Prop({ type: StructExamQuestionConfig, default: null })
  questionConfig!: StructExamQuestionConfig | null;
  showMoreActions = false;
  editVisible = false;
  // 正在编辑的维度
  edittingDimension = "";
  // 正在编辑的选项
  edittingOption = "";

  sortTo = 1; //移至第几
  popShow = false; //排序框
  deleteVisible = false;

  scoreConfigMap = {};
  groupDelText = "";
  groupName = "";
  deleteType = 0;
  cancelQ = new QuestionV2();
  // 展开题卡编辑
  expand = true;
  // 其他设置选项
  otherConfigOptions = [
    [
      {
        value: -1,
        label: "不限制"
      },
      {
        value: 3,
        label: "3秒"
      },
      {
        value: 5,
        label: "5秒"
      },
      {
        value: 10,
        label: "10秒"
      },
      {
        value: 30,
        label: "30秒"
      },
      {
        value: 60,
        label: "1分钟"
      },
      {
        value: 120,
        label: "2分钟"
      },
      {
        value: 180,
        label: "3分钟"
      }
    ],

    [
      {
        value: -1,
        label: "不限制"
      },
      {
        value: 60,
        label: "1分钟"
      },
      {
        value: 60 * 2,
        label: "2分钟"
      },
      {
        value: 60 * 3,
        label: "3分钟"
      },
      {
        value: 60 * 4,
        label: "4分钟"
      },
      {
        value: 60 * 5,
        label: "5分钟"
      },
      {
        value: 60 * 6,
        label: "6分钟"
      },
      {
        value: 60 * 10,
        label: "10分钟"
      },
      {
        value: 60 * 15,
        label: "15分钟"
      },
      {
        value: 60 * 20,
        label: "20分钟"
      },
      {
        value: 60 * 30,
        label: "30分钟"
      }
    ],

    [
      {
        value: -1,
        label: "不限制"
      },
      {
        value: 1,
        label: "1"
      },
      {
        value: 2,
        label: "2"
      },
      {
        value: 3,
        label: "3"
      },
      {
        value: 4,
        label: "4"
      },
      {
        value: 5,
        label: "5"
      }
    ]
  ];

  //内部使用
  get setWeb(): boolean {
    return this.$route?.query?.teamUse === "setWeb";
  }

  get hasQuestion() {
    return this.questionGroup.questionList.length > 0;
  }

  getInfo(info: {
    questionList: QuestionV2[];
    questionType: number;
    dimensionScoreConfigList: StructRandomQuestionScoreConfig[];
    name: string;
    questionIdList: number[];
    deleteType?: number;
  }) {
    if (info.deleteType === 1) {
      this.deleteGroupItem();
      return;
    }
    this.questionGroup.questionType = info.questionType;
    this.questionGroup.questionList = info.questionList;
    this.questionGroup.dimensionScoreConfigList = info.dimensionScoreConfigList;
    this.questionGroup.name = info.name;
    this.questionGroup.questionIdList = info.questionIdList;
    this.questionGroup.examQuestionConfig.commentConfigList = [];
    this.questionGroup.questionNumber = 1;
    this.initScoreConfig();
    this.catchQuestionNumber();
    this.$emit("chooseQuestion", info.questionIdList, this.index);
    // this.questionGroup.questionList.push(...selectedQuestionList)
  }

  editGroup() {
    this.editVisible = true;
  }

  hasFuScore(options: any) {
    let flag = false;
    options?.forEach((d: any) => {
      if (d.score < 0) flag = true;
    });
    return flag;
  }
  allFuScore(options: any) {
    let flag = true;
    options?.forEach((d: any) => {
      if (d.score >= 0) flag = false;
    });
    return flag;
  }

  @Emit()
  closeOtherPop() {
    return this.getQuestionGroupKey();
  }

  onCloseOtherPop(questionId: number) {
    if (questionId != this.getQuestionGroupKey()) {
      this.popShow = false;
    }
  }

  getQuestionGroupKey() {
    if (this.questionGroup.questionIdList.length > 0)
      return this.questionGroup.questionIdList[0];
    else return 0;
  }

  deleteGroupItem(hasConfirm?: boolean) {
    if (hasConfirm) {
      this.$confirm(
        "是否删除本组题目，删除后所有的配置信息将被删除。",
        "删除",
        {
          customClass: "delete-group-confirm",
          cancelButtonClass: "cancel-btn",
          confirmButtonClass: "confirm-btn"
        }
      ).then(() => {
        this.$emit("del", this.index);
      });
    } else {
      this.$emit("del", this.index);
    }
  }

  initScoreConfig() {
    if (this.scoreConfigList) {
      this.scoreConfigMap = {};
      for (const questionId of this.questionGroup.questionIdList) {
        if (!this.scoreConfigMap[questionId])
          this.scoreConfigMap[questionId] = [];

        for (const config of this.scoreConfigList) {
          if (config.questionId == questionId) {
            this.scoreConfigMap[questionId].push(config);
          }
        }
      }
    }
  }

  changeSelect() {
    this.change();
  }

  changeQuestionNumber(num: number) {
    this.$emit("changeQuestionNumber", this.questionGroup);
  }

  getInputClass(dimKey: string) {
    if (this.edittingDimension == dimKey) {
      return "dim-total-score-editting";
    } else
      return this.canEditScore
        ? this.currentDimension && this.currentDimension.dimensionKey == dimKey
          ? "dim-total-score-hightlight"
          : ""
        : "input-disable";
  }

  getOptionInputClass(questionId: any, key: string) {
    if (this.edittingOption == questionId + "-" + key)
      return "dim-config-option-score-editting";
    return this.canEditScore ? "" : "input-disable";
  }
  inputDimScore(config: StructExamScoreConfig, e: any) {
    const value = e.target.value;
    config.dimensionScore = Math.max(
      0,
      Math.min(100, Math.round(Number(value)))
    );
    config.videoQuestionScore = config.dimensionScore;

    // 为选择题重新分配分数
    if (this.questionGroup.isSingleSelect()) {
      for (const question of this.questionGroup.questionList) {
        const questionConfig = this.getSelectQuestionScoreConfig(
          question.questionId
        );
        questionConfig.dimensionScore = config.dimensionScore;
        questionConfig.choiceQuestionScoreList = [];
        for (const option of question.optionList) {
          const optionConfig = new ChoiceQuestionScore();
          optionConfig.optionKey = option.optionKey;
          optionConfig.content = option.content;
          if (option.defaultScorePercent != undefined)
            optionConfig.score = Math.round(
              (Number(option.defaultScorePercent) *
                questionConfig.dimensionScore) /
                100
            );
          questionConfig.choiceQuestionScoreList.push(optionConfig);
        }
      }
    }
    // 填空题配分
    if (this.questionGroup.isBlankQuestion()) {
      for (const question of this.questionGroup.questionList) {
        const a = this.getSelectQuestionScoreConfig(question.questionId);
        if (question.blankQuestionConfig.scoreType === 3) {
          //每空分数独立计分 3  根据每空分数比例分配
          const scoreList: number[] = [];
          question.blankQuestionConfig.answerList.forEach((an, i) => {
            if (i < question.blankQuestionConfig.answerList.length - 1) {
              scoreList.push(Math.floor(Number((an.score / 100) * value)));
            } else {
              scoreList.push(value - scoreList.reduce((a, b) => a + b, 0));
            }
          });
          a.dimensionScore = scoreList.reduce((a, b) => a + b, 0);
          a.blankQuestionScoreList = scoreList;
        } else {
          //整体比例计分 1 2； 此时只需题目总分
          a.dimensionScore = value; // 冗余字段 // 填空题 = sum(blankQuestionScoreList)
          a.blankQuestionScoreList = [value];
        }
      }
    }

    this.changeScore(config.dimensionKey, config.dimensionScore);
    if (this.edittingDimension == config.dimensionKey) {
      this.edittingDimension = "";
    }
  }

  inputOptionScore(questionId: any, option: any, e: any) {
    const value = e.target.value;
    option.score = Math.max(-100, Math.min(100, Math.round(Number(value))));
    const config = this.getSelectQuestionScoreConfig(questionId);
    let maxScore = 0;
    if (config) {
      for (const option of config.choiceQuestionScoreList) {
        if (option.score > maxScore) maxScore = option.score;
      }
      config.dimensionScore = maxScore;
      config.videoQuestionScore = maxScore;
      this.questionGroup.dimensionScoreConfigList.forEach(el => {
        el.dimensionScore = maxScore;
      });
      this.changeScore(config.dimensionKey, config.dimensionScore);
    }
    if (this.edittingOption == option.optionKey) {
      this.edittingOption = "";
    }
  }

  //用户手动改填空某空分值
  inputBlankScore(questionId: any, score: number, e: any) {
    const config = this.getSelectQuestionScoreConfig(questionId);
    if (config) {
      const score = config.blankQuestionScoreList.reduce(
        (a: number, b: number) => Number(a) + Number(b),
        0
      );
      this.questionGroup.dimensionScoreConfigList.forEach(el => {
        el.dimensionScore = score;
      });
      config.dimensionScore = score;
      this.changeScore(config.dimensionKey, score);
    }
  }

  getSelectQuestionScoreConfig(questionId: any) {
    if (
      this.scoreConfigMap[questionId] &&
      this.scoreConfigMap[questionId].length > 0
    )
      return this.scoreConfigMap[questionId][0];
    else return {};
  }

  //限制正整数
  setSortTo(a: any) {
    this.sortTo =
      Number(a.replace(/[^\d]/g, "")) > 0 ? Number(a.replace(/[^\d]/g, "")) : 0;
  }

  //排序
  sort() {
    if (!this.sortTo) {
      this.$message.warning("请输入正整数");
      return;
    }
    this.popShow = false;
    this.$emit("sort", this.sortTo);
  }

  changePreparetionTime() {
    if (
      this.questionGroup.examQuestionConfig &&
      this.questionGroup.examQuestionConfig.preparationTime != -1
    ) {
      this.questionGroup.examQuestionConfig.submitNumberLimit = 1;
    }
    if (this.questionGroup.examQuestionConfig.preparationTime === -1) {
      this.questionGroup.examQuestionConfig.openPreparationTimeSound = 2;
    }
  }

  mounted() {
    this.initData(this.questionGroup);
    this.questionGroup.expand = true;
    this.onActionsChange(this.actions);
  }

  @Watch("questionGroup", { immediate: true })
  initData(to: any, from: any = null) {
    this.initScoreConfig();
  }

  @Watch("actions")
  onActionsChange(to: any, from: any = null) {
    this.showMoreActions = false;
    if (this.actions && this.actions.length > 0) {
      for (const action of this.actions) {
        if (action.enable) {
          this.showMoreActions = true;
        }
      }
    }
  }

  @Emit()
  editQuestion(question: any) {
    return question;
  }

  confirmDel() {
    if (this.deleteType === 1) {
      this.deleteGroupItem();
      this.deleteVisible = false;
    } else if (this.deleteType === 2) {
      this.regetQuestion(this.cancelQ);
      this.deleteVisible = false;
    }
  }

  deleteQuestion(question: QuestionV2) {
    if (this.questionGroup.questionList.length === 1) {
      // 最后一题逻辑
      this.deleteType = 1;
      this.groupDelText =
        "由于该题目是以下分组的最后一道题，删除后系统将同时删除该题目分组的全部设置：";
      this.groupName = `组${this.index + 1}：${this.questionGroup.name ||
        "抽题组卷题"} ｜ ${this.questionGroup.questionList.length}抽${
        this.questionGroup.questionNumber
      } ｜ ${this.questionGroup.getQuestionTypeText()}`;
      this.deleteVisible = true;
      // this.deleteGroupItem()
    } else {
      if (
        this.questionGroup.questionList.length ===
        this.questionGroup.questionNumber
      ) {
        this.cancelQ = question;
        this.deleteType = 2;
        this.groupDelText =
          "删除该题目后，系统将变更以下题目分组的抽题数量，如有不妥请及时调整：";
        this.groupName = `组${this.index + 1}：${this.questionGroup.name ||
          "抽题组卷题"} ｜ ${this.questionGroup.questionList.length}抽${
          this.questionGroup.questionNumber
        } ｜ ${this.questionGroup.getQuestionTypeText()}`;
        this.deleteVisible = true;
        return;
      }
      this.regetQuestion(question);
    }
    // return this.question;
  }

  // 重新获取题目组信息
  regetQuestion(question: QuestionV2) {
    const selectedQuestion = this.questionGroup.questionList.filter(
      el => el.questionId !== question.questionId
    );
    const dimensionKeyList: any = [];
    selectedQuestion.forEach(question => {
      dimensionKeyList.push(
        ...question.dimensionListFilter.map(el => el.dimensionKey)
      );
    });
    const dimensionScoreConfigList = selectedQuestion[0]?.dimensionListFilter.filter(
      el => dimensionKeyList.includes(el.dimensionKey)
    );
    const temp: StructRandomQuestionScoreConfig[] = [];
    dimensionScoreConfigList.forEach(el => {
      const item = this.questionGroup.dimensionScoreConfigList.filter(
        item => item.dimensionKey === el.dimensionKey
      );
      const obj = new StructRandomQuestionScoreConfig();
      obj.backgroundColor = el.backgroundColor;
      obj.color = el.color;
      obj.dimensionKey = el.dimensionKey;
      obj.dimensionName = el.dimensionName;
      obj.dimensionScore = item.length > 0 ? Number(item[0].dimensionScore) : 0;
      temp.push(obj);
    });
    this.getInfo({
      questionList: selectedQuestion,
      questionIdList: selectedQuestion.map(el => el.questionId),
      questionType: selectedQuestion[0]?.questionType || 1,
      dimensionScoreConfigList: temp,
      name: this.questionGroup.name
    });
  }

  // 处理抽题数量
  catchQuestionNumber() {
    if (
      this.questionGroup.questionNumber > this.questionGroup.questionList.length
    ) {
      this.questionGroup.questionNumber = this.questionGroup.questionList.length;
      this.$emit("getTotal");
    }
  }

  @Emit()
  change() {
    // return this.question.questionId;
  }

  @Emit()
  changeScore(dimKey: string, score: number) {
    return {
      questionGroup: this.questionGroup,
      dimKey: dimKey,
      score: score
    };
  }

  @Emit()
  menuItemClick(index: number) {
    // return { questionId: this.question, eventId: index };
  }
}
